import React from "react";
import "./Testi.css";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

// import required modules
import { Autoplay, Navigation } from "swiper/modules";
import { Container, Row } from "react-bootstrap";
const Testimonial = () => {
  const testimonial = [
    {
      name: "Manish Albela",
      role: "Artist",
      review:
        "FTtunes transformed my music journey in ways I never imagined. Their dedication and expertise made my dreams come true. I highly recommend FTtunes to any artist looking to take their career to the next level.",
      src: "/Images/hall-of-fame/manish-albela.jpg",
    },
    {
      name: "Micle Amit",
      role: "Music Producer",
      review:
        "FTtunes has been a game-changer for me. They’ve helped me reach audiences I never thought possible. Their support and passion for music have made all the difference in my career.",
      src: "/Images/hall-of-fame/micle-amit.jpg",
    },
    {
      name: "Rajeshwari Singh",
      role: "Singer/Songwriter",
      review:
        "Thanks to FTtunes, my music is now heard around the world. They provided the platform and tools I needed to grow. I couldn’t be happier with their service and highly recommend them.",
      src: "/Images/hall-of-fame/rajeshwari-singh.jpg",
    },
    {
      name: "Ritik Gupta",
      role: "Independent Artist",
      review:
        "FTtunes is more than a distribution company; they're partners in my artistic journey. Their commitment to helping artists succeed has made them invaluable to my music career.",
      src: "/Images/hall-of-fame/ritik-gupta.jpg",
    },
  ];

  return (
    <section className="testimonial-section">
      <Container>
        <div className="testimonial-header text-center mb-5">
          <h6 className="text-uppercase text-purple mb-3"><mark>TESTIMONIALS</mark></h6>
          <h2 className="heading-testimonial text-white">
            What Are <mark>Artists</mark>{" "}
            Saying About FTtunes?
          </h2>
        </div>

        <div className="testimonial-slider-wrapper">
          <Swiper
            navigation={{
              nextEl: ".swiper-button-next-testi",
              prevEl: ".swiper-button-prev-testi",
            }}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            loop={true}
            modules={[Navigation, Autoplay]}
            className="testimonial-swiper"
          >
            {testimonial.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="testimonial-card">
                  <div className="quote-icon">
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path
                        d="M14.017 21L14.017 18C14.017 16.8954 14.9124 16 16.017 16H19.017C19.5693 16 20.017 15.5523 20.017 15V9C20.017 8.44772 19.5693 8 19.017 8H16.017C14.9124 8 14.017 8.89543 14.017 10V13M5.017 21L5.017 18C5.017 16.8954 5.91243 16 7.017 16H10.017C10.5693 16 11.017 15.5523 11.017 15V9C11.017 8.44772 10.5693 8 10.017 8H7.017C5.91243 8 5.017 8.89543 5.017 10V13"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill="none"
                      />
                    </svg>
                  </div>
                  <p className="testimonial-text">{item.review}</p>
                  <div className="testimonial-author">
                    <div className="author-image-wrapper">
                      <img
                        src={item.src}
                        alt={item.name}
                        className="author-image"
                      />
                    </div>
                    <div className="author-info">
                      <h4 className="author-name">{item.name}</h4>
                      <p className="author-role"><mark>{item.role}</mark></p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="swiper-button-prev-testi">
            <svg
              viewBox="0 0 24 24"
              width="24"
              height="24"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
            >
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
          </div>
          <div className="swiper-button-next-testi">
            <svg
              viewBox="0 0 24 24"
              width="24"
              height="24"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
            >
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Testimonial;
